export const DELIVERY_INFO = 'Delivery information';
